<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <span>
    <b-dropdown
      left
      data-test="articles-actions-dropdown-button"
      variant="plain"
      toggle-class="text-decoration-none"
      no-caret
      size="sm"
    >
      <template v-slot:button-content>
        <i class="fa-light fa-ellipsis-v" />
      </template>
      <b-dropdown-item
        @click="openArticleModal"
        v-if="isViewType('Editor')"
        data-test="add-article"
        :disabled="isCampaignReadonly"
      >
        Add an article
      </b-dropdown-item>
      <b-dropdown-item
        @click="selectOnlyDraft"
        data-test="select-only-draft-items"
        v-if="isViewType('Showcase')"
        :disabled="isCampaignReadonly"
      >
        Select Only Draft Items
      </b-dropdown-item>
      <b-dropdown-item
        @click="approveDraftItems"
        data-test="submit-all-draft-items-for-approval"
        v-if="isViewType('Editor')"
        :disabled="isCampaignReadonly"
      >
        Submit All Draft Items For Approval
      </b-dropdown-item>
      <b-dropdown-item
        @click="viewFeed"
        data-test="view-feed"
        v-if="isManagedCampaign && (isViewType('Setup') || isViewType('Editor'))"
      >
        View feed
      </b-dropdown-item>
    </b-dropdown>

    <b-modal
      id="AddArticleModal"
      title="Add new articles"
      size="lg"
      hide-footer
      v-if="isViewType('Editor')"
    >
      <ContentInfo
        ref="contentInfo"
        :advertisers-id="selectedAdvertiser.id"
        :campaign-feed-id="feedId"
        :disable-delete="true"
        @setNotValidForNavigation="updateIsNotValidForNavigation"
      />
      <b-button
        :disabled="isNotValidLastButton || isNotValidNextButton || isLoading"
        size="lg"
        variant="primary"
        data-test="submit-button"
        class="ml-auto"
        @click="onSubmit"
        :class="{ 'btn-loading': isLoading }"
      >
        Submit
      </b-button>
    </b-modal>
  </span>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import * as types from '@/modules/content/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';


import ContentInfo from '@/modules/content/components/ContentInfo';
import suppressibleBox from '@/core/mixins/suppressibleBox';

export default {
  name: 'ArticlesActions',
  mixins: [
    suppressibleBox,
  ],
  components: {
    ContentInfo,
  },
  props: {
    viewType: {
      type: String,
      default: 'Editor',
    },
  },
  data() {
    return {
      isLoading: false,
      isNotValidLastButton: false,
      isNotValidNextButton: false,
    };
  },
  computed: {
    ...mapState('campaigns', [
      'selectedAdvertiser',
      'order',
    ]),
    ...mapGetters('campaigns', {
      isCampaignReadonly: campaignTypes.GET_IS_CAMPAIGN_READONLY,
      isManagedCampaign: campaignTypes.GET_IS_MANAGED_CAMPAIGN,
    }),
    ...mapState('content', [
      'creative',
      'feedId',
    ]),
  },
  methods: {
    ...mapActions('content', [
      types.FETCH_EXISTING_CONTENT_SCRAPES,
    ]),
    openArticleModal() {
      this.$root.$emit('bv::show::modal', 'AddArticleModal');
    },
    selectOnlyDraft() {
      this.$emit('selectOnlyDraft');
    },
    viewFeed() {
      window.open(`${process.env.VUE_APP_SMARTCONSOLE_HOST}/content-sources/${this.feedId}/content-items`, '_blank');
    },
    approveDraftItems() {
      this.boxOk(
        'Information',
        'All ad content goes through an approvals process to make sure it\'s safe and appropriate for users. Approvals can take up to 2 working days.',
        'suppressSendForApprovalDialog',
      ).then(() => this.$emit('approveDraftItems'));
    },
    updateIsNotValidForNavigation(type, valid) {
      if (type === 'last') {
        this.isNotValidLastButton = valid;
      } else if (type === 'next') {
        this.isNotValidNextButton = valid;
      }
    },
    onSubmit() {
      this.isLoading = true;
      this.$refs.contentInfo.onSubmit();
      setTimeout(() => {
        this.$root.$emit('bv::hide::modal', 'AddArticleModal');
        this.$emit('contentScrapeUpdate');
        this.isLoading = false;
      }, 2000);
    },
    isViewType(viewType) {
      return this.viewType === viewType;
    },
  },
  mounted() {
    if (this.isViewType('Editor')) {
      // this.FETCH_EXISTING_CONTENT_SCRAPES(this.creative.campaignId);
    }
  },
};
</script>
